import { render, staticRenderFns } from "./jumpPageH5.vue?vue&type=template&id=8dca4424&"
import script from "./jumpPageH5.vue?vue&type=script&lang=js&"
export * from "./jumpPageH5.vue?vue&type=script&lang=js&"
import style0 from "./jumpPageH5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports